import React, {useContext, useState} from 'react';

import {Avatar} from "@mui/material";

import {SidebarContext} from "../../../../../../../SidebarContext";

import {ReactComponent as More} from "assets/img/wms/more.svg";
import {ReactComponent as ConnectionPin} from "assets/img/connectionPin.svg";

import {greenColor, grey300, grey50, greyishBlue100, greyishBlue500, greyishBlue900} from "assets/jss/main";

function UserInfos() {
    const {currentMember} = useContext(SidebarContext);

    const [isHovered, setIsHovered] = useState(false);

    if (!currentMember) {
        return null;
    }

    const {givenName, familyName, picture, email} = currentMember;

    return (
        <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                display: 'flex',
                padding: '11px 8px',
                border: `1px solid ${greyishBlue100}`,
                borderRadius: '8px',
                marginTop: '4px',
                alignItems:'center',
                cursor: 'pointer',
                background: isHovered ? grey300 : grey50,
            }}
        >
            {picture ? (
                <div style={{position: "relative"}}>
                    <Avatar
                        alt={'avatar'}
                        variant='rounded'
                        src={picture}
                        style={{
                            width: 32,
                            height: 32,
                            objectFit: 'cover',
                            borderRadius: '4px'
                        }}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top:"-5px",
                            right: "-5px",
                            display: 'flex'
                        }}
                    >
                        <ConnectionPin color={greenColor} />
                    </div>
                </div>
            ) : (
                <Avatar
                    variant='rounded'
                    sx={{
                        width: 32,
                        height: 32,
                    }}
                >
                    {givenName && givenName.charAt(0)}
                    {familyName && familyName.charAt(0)}
                </Avatar>
            )}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                fontSize: '10px',
                marginLeft: '8px',
                overflow: 'hidden'
            }}>
                <div style={{
                    fontWeight: 600,
                    color: greyishBlue900,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap'
                }}>
                    {givenName}
                </div>
                <div style={{
                    color: greyishBlue500,
                    fontWeight: 400,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap'
                }}>
                    {email}
                </div>
            </div>
            <More style={{
                width: 20,
                height: 20,
                minWidth: 20,
                marginLeft: 'auto'
            }} />
        </div>
    );
}

export default UserInfos;
